import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { USER_INPUT_DEBOUNCE_TIME } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'header-form',
    templateUrl: './header-form.component.html',
    styleUrls: ['./header-form.component.scss'],
})
export class HeaderFormComponent implements OnInit {
    headerCaptionControl: FormControl<string>;

    @Input() headerCaption: string | undefined;

    @Output() headerCaptionChange = new EventEmitter<string>();
    @Output() saveHeaderCaption = new EventEmitter<string>();
    @Output() eraseHeaderForm = new EventEmitter<void>();

    constructor(private readonly matIconRegistry: MatIconRegistry, private readonly domSanitizer: DomSanitizer) {
        this.matIconRegistry.addSvgIcon(
            'save',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/aumico-pattern-icon-save.svg'),
        );
        this.matIconRegistry.addSvgIcon(
            'close',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/aumico-pattern-icon-cancel-gray.svg'),
        );
    }

    ngOnInit(): void {
        if (this.headerCaption != null) {
            this.headerCaptionControl = new FormControl(this.headerCaption, Validators.required);
        } else {
            this.headerCaptionControl = new FormControl('', Validators.required);
        }

        this.headerCaptionControl.valueChanges
            .pipe(debounceTime(USER_INPUT_DEBOUNCE_TIME), distinctUntilChanged(), untilDestroyed(this))
            .subscribe((caption: string) => {
                const trimmedCaption = caption.trim();
                this.headerCaptionChange.emit(trimmedCaption);
            });
    }

    onSaveHeaderCaption(): void {
        this.saveHeaderCaption.emit(this.headerCaptionControl.value);
    }

    onCancel(): void {
        this.eraseHeaderForm.emit();
    }
}
